import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.css'],
    standalone: false
})
export class MenuComponent implements OnInit {
  public takeInHand = localStorage.getItem('takeInHand');
  constructor() { }

  ngOnInit() {
  }

  logout_user() {

  }
}
